export default __webpack_public_path__ + "f5abf0b43f6baeace477abcd1692d94c.png";